module.exports = __webpack_public_path__ + "img/interveneIcon.83632523.png";